import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["data", "dragborder", "draggable", "className"];
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { compare, ObjectAssign } from './util';
/**
 * 参数: 列拖拽
 * @param {*} Table
 */

export default function dragColumn(Table) {
  return /*#__PURE__*/function (_Component) {
    _inherits(DragColumn, _Component);

    var _super = _createSuper(DragColumn);

    function DragColumn(props) {
      var _this;

      _classCallCheck(this, DragColumn);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "setColumOrderByIndex", function (_column) {
        _column.forEach(function (da, i) {
          da.dragIndex = i;
          da.drgHover = false;
        });

        return _column;
      });

      _defineProperty(_assertThisInitialized(_this), "onDragEnd", function (event, data) {
        var dragSource = data.dragSource,
            dragTarget = data.dragTarget;
        var columns = _this.state.columns;
        var sourceIndex = -1,
            targetIndex = -1;
        sourceIndex = columns.findIndex(function (da, i) {
          return da.key == dragSource.key;
        });
        targetIndex = columns.findIndex(function (da, i) {
          return da.key == dragTarget.key;
        }); // 向前移动

        if (targetIndex < sourceIndex) {
          targetIndex = targetIndex + 1;
        }

        columns.splice(targetIndex, 0, columns.splice(sourceIndex, 1)[0]);
        var sortedColumns = [];
        columns.forEach(function (da, i) {
          sortedColumns.push(Object.assign({}, da));
        });

        _this.setState({
          columns: sortedColumns
        });

        if (_this.props.onDragEnd) {
          _this.props.onDragEnd(event, data, sortedColumns);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "getTarget", function (evt) {
        return evt.target || evt.srcElement;
      });

      _this.state = {
        columns: _this.setColumOrderByIndex(props.columns)
      };
      return _this;
    }

    _createClass(DragColumn, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.columns != this.props.columns) {
          this.setState({
            columns: this.setColumOrderByIndex(nextProps.columns)
          });
        }
      }
    }, {
      key: "recursion",
      value: function (_recursion) {
        function recursion(_x) {
          return _recursion.apply(this, arguments);
        }

        recursion.toString = function () {
          return _recursion.toString();
        };

        return recursion;
      }(function (obj) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        for (var key in obj) {
          if (_typeof(obj[key]) == 'object' && Object.keys(obj[key].length > 0)) {
            data[key] = recursion(obj[key]);
          } else {
            data[key] = obj[key];
          }
        }

        return data;
      } //拖拽交互列后触发
      )
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            data = _this$props.data,
            dragborder = _this$props.dragborder,
            draggable = _this$props.draggable,
            className = _this$props.className,
            others = _objectWithoutProperties(_this$props, _excluded);

        return /*#__PURE__*/React.createElement(Table, _extends({}, others, {
          columns: this.state.columns,
          data: data,
          ref: function ref(el) {
            return _this2.table = el;
          },
          className: "".concat(className, " u-table-drag-border"),
          onDragEnd: this.onDragEnd,
          draggable: draggable,
          dragborder: dragborder
        }));
      }
    }]);

    return DragColumn;
  }(Component);
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/lib/dragColumn.js